<template>
    <dashboard-layout>
        <div>
            <h3>{{ chapter.name }}</h3><br/>
            <div v-html="chapter.content"></div>
            <div class="accordion" id="accordionExample">
                <div class="accordion-item" v-for="item in items?.data" :key="item.id">
                    <h2 class="accordion-header" :id="'heading' + item.id">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" :data-bs-target="'#collapse' + item.id" aria-expanded="false" :aria-controls="'collapse' + item.id">
                            {{ item.title }}
                        </button>
                    </h2>
                    <div :id="'collapse' + item.id" class="accordion-collapse collapse" :aria-labelledby="'heading' + item.id" data-bs-parent="#accordionExample">
                        <div class="accordion-body">
                            <div v-html="item?.content"></div>
                        </div>
                    </div>
                </div>
            </div>
            <Bootstrap5Pagination
                class="mb-0"
                :data="items"
                :limit="2"
                :show-disabled="false"
                :size="'default'"
                :align="'center'"
                @pagination-change-page="getResults"
            />
        </div>
    </dashboard-layout>
</template>

<script>
import { useToast } from "vue-toastification";
import { Bootstrap5Pagination } from 'laravel-vue-pagination';
import DashboardLayout from "../../dashboard-layout.vue";

const toast = useToast();

export default {
    components: {
        DashboardLayout,
        Bootstrap5Pagination
    },
    data() {
        return {
            items: [],
            chapter: [],
            q: this.$route.query,
            form_options: {},
        }
    },
    created() {
        this.getResults();
        // this.show( this.$route?.params?.chapter_id );
    },
    methods: {
        getResults(page = this.$route?.query?.page ?? 1) {
            const id = toast.info('Getting content ...', { icon: 'fa-solid fa-download' });

            axios.get('book_sections', {
                params: {
                    'page': page,
                    'chapter_id': this.$route?.params?.chapter_id,
                    'subscribe_id': this.$route?.params?.subscribe_id
                }
            }).then(response => {
                toast.dismiss(id);
                this.items = response.data;
                this.chapter = response.data.chapter.data;
            }).catch(error => {
                toast.dismiss(id);
                toast.error(`Error: ${error.response ? error.response.data.message : 'An error occurred'}`);
            });
        },
        // show(chapter_id) {
        //
        //     const id = toast.info('Getting content ...',{ icon: 'fa-solid fa-download' });
        //
        //     axios.get(`book_chapters/${chapter_id}`, {}).then(response => {
        //
        //         this.chapter = response.data.data;
        //
        //         toast.dismiss(id);
        //     }, response => {
        //         toast.dismiss(id);
        //     });
        // }
    }
}
</script>
